module.exports = __webpack_public_path__ + "img/error_img@2x.8d365f9e.png";